import { render, staticRenderFns } from "./hasBeenStoredDetail.vue?vue&type=template&id=6cbe0650&scoped=true"
import script from "./hasBeenStoredDetail.vue?vue&type=script&lang=js"
export * from "./hasBeenStoredDetail.vue?vue&type=script&lang=js"
import style0 from "./hasBeenStoredDetail.vue?vue&type=style&index=0&id=6cbe0650&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbe0650",
  null
  
)

export default component.exports